import { SceneConstants } from "./SceneConstants";
import { Coating, ComponentConstants, JoineryType, Credence } from "../components/ComponentModule";
import { Joinery, Door, Canopy, FrenchDoor, PictureWindow, Niche, CupboardDoor, Window } from "./Joineries/JoineryModule";
import { Wall } from "./Wall";

export class EntityDefaultPropertiesManager {

    managerName: string = 'EntityDefaultPropertiesManager';

    joineriesDefaultProperties = [
        { //door
            length: 830,
            height: 2040,
            floorHeight: 0,
            nbDoors: 1,
            openingMode: SceneConstants.OpeningMode.mode_default,
            slideDirection: SceneConstants.SlideDirection.slide_left,
            handleSide: SceneConstants.HandleSide.handle_left,
            openingSymetry: SceneConstants.Symetry.default
        },
        {//opening
            length: SceneConstants.DefaultShortJoineryLength,
            height: SceneConstants.DefaultJoineryHeight,
            floorHeight: 0
        },
        {//window
            length: 1200,
            height: 1250,
            floorHeight: SceneConstants.DefaultWindowFloorHeight,
            nbCasement: 2,
            openingMode: SceneConstants.OpeningMode.mode_default,
            slideDirection: SceneConstants.SlideDirection.slide_left,
            handleSide: SceneConstants.HandleSide.handle_center,
            openingSymetry: SceneConstants.Symetry.default
        },
        {//frenchWindow
            length: 1400,
            height: SceneConstants.DefaultJoineryHeight,
            floorHeight: 0,
            nbDoors: 2,
            handleSide: SceneConstants.HandleSide.handle_center,
            openingSymetry: SceneConstants.Symetry.default
        },
        {//pictureWindow
            length: 2000,
            height: SceneConstants.DefaultJoineryHeight,
            floorHeight: 0,
            nbDoors: 2,
            slideDirection: SceneConstants.SlideDirection.slide_left
        },
        {},
        {//canopy
            length: SceneConstants.DefaultLongJoineryLength,
            height: SceneConstants.DefaultCanopyHeight,
            floorHeight: 1100,
            nbCasement: 3
        },
        {//cupboard
            length: SceneConstants.DefaultShortJoineryLength,
            height: SceneConstants.DefaultCupboardDoorHeight,
            floorHeight: 0,
            nbDoors: 2
        },
        {//garage
            length: 2000,
            height: SceneConstants.DefaultJoineryHeight,
            floorHeight: 0
        },
        { //FrontDoor
            length: 930,
            height: 2150,
            floorHeight: 0,
            nbDoors: 1,
            openingMode: SceneConstants.OpeningMode.mode_default,
            slideDirection: SceneConstants.SlideDirection.slide_left,
            handleSide: SceneConstants.HandleSide.handle_left,
            openingSymetry: SceneConstants.Symetry.default
        },
        { //Niche
            length: 500,
            height: 500,
            thickness: 50,
            floorHeight: 1000
        },
        {//fixedwindow
            length: SceneConstants.DefaultShortJoineryLength,
            height: SceneConstants.DefaultJoineryHeight,
            floorHeight: 0,
        },
        {//velux
            length: SceneConstants.DefaultVeluxLength,
            height: SceneConstants.DefaultVeluxHeight,
        }
    ];
    wallDefaultProperties = {
        thickness: SceneConstants.DefaultWallThickness,
        height: SceneConstants.DefaultWallHeight
    };

    worktopDefaultProperties = {
        coating: null as any,
        coatingIndex: null as any,
        credence: null as any,
        credenceIndex: null as any
    }

    // Ixina default box coating (blanc alpin)
    kitchenDefaultBoxCoating: string = '664e0d00b751b3c903290f2c';
    // Ixina default door coating (blanc alpin)
    kitchenDefaultDoorCoating : string = '664e0d00b751b3c903290f2c';
    // Ixina default gutter (blanc)
    kitchenDefaultGutterCoating : string = '664e03da64627953adabb0f9';
    // Ixina default sink coating (black)
    kitchenDefaultSinkCoating : string = '6662d680acf8b05f4af1df59';
    // Ixina default mixer coating (black)
    kitchenDefaultMixerCoating : string = '6662d5578be1195f9e87f0b3';
    kitchenDefaultPanelCoating : string = '5f21626db36b241d008438de';
    kitchenDefaultShelfCoating : string = '5f855dcb332bbf3a4903e354';
    kitchenDefaultBackCoating : string = '5f855dcb332bbf3a4903e354';

    kitchenDefaultButtonCoating : string = '608fef9f13242344fa7c691d';
    kitchenDefaultFlatPieceCoating : string = '608fc5e602c83f452ad5fc47';

    kitchenDefaultTopBottomCoating : string = '5f21626db36b241d008438de';
    // Ixina default plinth coating (blanc alpin)
    kitchenDefaultPlinthCoating : string = '664e0d00b751b3c903290f2c';
    // Ixina default plinth coating (blanc alpin)
    kitchenDefaultWorktopCoating : string = '664e06b91dec26c8c78fc3f9';
    // Ixina default plinth coating (blanc alpin)
    kitchenDefaultCredenceCoating : string = '664e0fb66494cec8af8b2381';
    // New Ixina Handle
    kitchenDefaultHandle : string = '664eff3c3f2e38c8a9aa2600';

    storageDefaultHandle : string = '670f74deec7b5034547449e0';
    storageDefaultBoxCoating : string = '670e87fe970bd168a0d72118';
    storageDefaultDoorCoating : string = '670e87fe970bd168a0d72118';
    storageDefaultShelfCoating : string = '670e87fe970bd168a0d72118';

    // TODO
    bathroomDefaultHandle : string = '643e9d574032ec03b4d904b2';
    bathroomDefaultBoxCoating : string = '67b34a0267acfc1f93145218';
    bathroomDefaultMirrorBorderCoating = '67b34a0267acfc1f93145218';

    roomCoatingClipboard: Coating | null = null;
    decoratedWallClipboard: Wall | null = null;
    joineryClipboard: Joinery | null = null;

    doorCustomizationGroups = null;

    constructor() {

    }

    static getInstance(): EntityDefaultPropertiesManager {
        const g = globalThis as any;
        if (!g.__rhinov_EntityDefaultPropertiesManager_instance) {
            g.__rhinov_EntityDefaultPropertiesManager_instance = new EntityDefaultPropertiesManager;
        }
        return g.__rhinov_EntityDefaultPropertiesManager_instance;
    }

    setJoineryDefaultProperties(joinery: Joinery) {

        var type = joinery.joineryType;
        this.joineriesDefaultProperties[type].length = joinery.length;
        this.joineriesDefaultProperties[type].height = joinery.height;
        this.joineriesDefaultProperties[type].floorHeight = joinery.floorHeight;
        var joinerytmp: Canopy | Door | Window | FrenchDoor | PictureWindow | Niche | CupboardDoor;

        switch (type) {
            case SceneConstants.JoineryType.door:
            case SceneConstants.JoineryType.frontDoor:
                joinerytmp = joinery as Door;
                this.joineriesDefaultProperties[type].openingMode = joinerytmp.openingMode;
                this.joineriesDefaultProperties[type].nbDoors = joinerytmp.nbDoors;
                this.joineriesDefaultProperties[type].slideDirection = joinerytmp.slideDirection;
                this.joineriesDefaultProperties[type].handleSide = joinerytmp.handleSide;
                this.joineriesDefaultProperties[type].openingSymetry = joinerytmp.openingSymetry;
                break;
            case SceneConstants.JoineryType.window:
                joinerytmp = joinery as Window;
                this.joineriesDefaultProperties[type].openingMode = joinerytmp.openingMode;
                this.joineriesDefaultProperties[type].nbCasement = joinerytmp.nbCasement;
                this.joineriesDefaultProperties[type].slideDirection = joinerytmp.slideDirection;
                this.joineriesDefaultProperties[type].handleSide = joinerytmp.handleSide;
                this.joineriesDefaultProperties[type].openingSymetry = joinerytmp.openingSymetry;
                break;
            case SceneConstants.JoineryType.frenchWindow:
                joinerytmp = joinery as FrenchDoor;
                this.joineriesDefaultProperties[type].nbDoors = joinerytmp.nbDoors;
                this.joineriesDefaultProperties[type].handleSide = joinerytmp.handleSide;
                this.joineriesDefaultProperties[type].openingSymetry = joinerytmp.openingSymetry;
                break;
            case SceneConstants.JoineryType.pictureWindow:
                joinerytmp = joinery as PictureWindow;
                this.joineriesDefaultProperties[type].nbDoors = joinerytmp.nbDoors;
                this.joineriesDefaultProperties[type].slideDirection = joinerytmp.slideDirection;
                break;
            case SceneConstants.JoineryType.niche:
                joinerytmp = joinery as Niche
                this.joineriesDefaultProperties[type].thickness = joinerytmp.thickness;
                break;
            case SceneConstants.JoineryType.canopy:
                joinerytmp = joinery as Canopy
                this.joineriesDefaultProperties[type].nbCasement = joinerytmp.nbCasement;
                break;
            case SceneConstants.JoineryType.cupboardDoor:
                joinerytmp = joinery as CupboardDoor;
                this.joineriesDefaultProperties[type].nbDoors = joinerytmp.nbDoors;
                break;
            case SceneConstants.JoineryType.fixedWindow:
                break;
            case SceneConstants.JoineryType.velux:
                break;
            default:
                break;
        }
    }

    resetJoineryDefaultProperties(type: number) {
        switch (type) {
            case 0:
                this.joineriesDefaultProperties[type].length = 830;
                this.joineriesDefaultProperties[type].height = 2040;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbDoors = 1;
                this.joineriesDefaultProperties[type].openingMode = SceneConstants.OpeningMode.mode_default;
                this.joineriesDefaultProperties[type].slideDirection = SceneConstants.SlideDirection.slide_left;
                this.joineriesDefaultProperties[type].handleSide = SceneConstants.HandleSide.handle_left;
                this.joineriesDefaultProperties[type].openingSymetry = SceneConstants.Symetry.default;
                break;

            case 1:
                this.joineriesDefaultProperties[type].length = SceneConstants.DefaultShortJoineryLength;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                break;

            case 2:
                this.joineriesDefaultProperties[type].length = 1200;
                this.joineriesDefaultProperties[type].height = 1250;
                this.joineriesDefaultProperties[type].floorHeight = SceneConstants.DefaultWindowFloorHeight;
                this.joineriesDefaultProperties[type].nbCasement = 2;
                this.joineriesDefaultProperties[type].openingMode = SceneConstants.OpeningMode.mode_default;
                this.joineriesDefaultProperties[type].slideDirection = SceneConstants.SlideDirection.slide_left;
                this.joineriesDefaultProperties[type].handleSide = SceneConstants.HandleSide.handle_center;
                this.joineriesDefaultProperties[type].openingSymetry = SceneConstants.Symetry.default;
                break;

            case 3:
                this.joineriesDefaultProperties[type].length = 1400;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbDoors = 2;
                this.joineriesDefaultProperties[type].handleSide = SceneConstants.HandleSide.handle_center;
                this.joineriesDefaultProperties[type].openingSymetry = SceneConstants.Symetry.default;
                break;

            case 4:
                this.joineriesDefaultProperties[type].length = 2000;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbDoors = 2;
                this.joineriesDefaultProperties[type].slideDirection = SceneConstants.SlideDirection.slide_left;
                break;

            case 5:
                break;

            case 6:
                this.joineriesDefaultProperties[type].length = SceneConstants.DefaultLongJoineryLength;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbCasement = 3;
                break;

            case 7:
                this.joineriesDefaultProperties[type].length = SceneConstants.DefaultShortJoineryLength;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbDoors = 2;
                break;

            case 8:
                this.joineriesDefaultProperties[type].length = 2000;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultJoineryHeight;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                break;

            case 9:
                this.joineriesDefaultProperties[type].length = 930;
                this.joineriesDefaultProperties[type].height = 2040;
                this.joineriesDefaultProperties[type].floorHeight = 0;
                this.joineriesDefaultProperties[type].nbDoors = 1;
                this.joineriesDefaultProperties[type].openingMode = SceneConstants.OpeningMode.mode_default;
                this.joineriesDefaultProperties[type].slideDirection = SceneConstants.SlideDirection.slide_left;
                this.joineriesDefaultProperties[type].handleSide = SceneConstants.HandleSide.handle_left;
                this.joineriesDefaultProperties[type].openingSymetry = SceneConstants.Symetry.default;
                break;

            case 10:
                this.joineriesDefaultProperties[type].length = 500;
                this.joineriesDefaultProperties[type].height = 500;
                this.joineriesDefaultProperties[type].thickness = 50;
                this.joineriesDefaultProperties[type].floorHeight = 1000;
                break;

            case SceneConstants.JoineryType.velux:
                this.joineriesDefaultProperties[type].length = SceneConstants.DefaultVeluxLength;
                this.joineriesDefaultProperties[type].height = SceneConstants.DefaultVeluxHeight;
                break;
        }
    }

    convertJoinery(source: any, dest:any) {

        var type = source.joineryType;
        dest.length = source.length;
        dest.height = source.height;
        dest.orientation = source.orientation;
        dest.floorHeight = source.floorHeight;
        switch (type) {
            case SceneConstants.JoineryType.door:
            case SceneConstants.JoineryType.frontDoor:
                dest.openingMode = source.openingMode;
                dest.nbDoors = source.nbDoors;
                dest.slideDirection = source.slideDirection;
                dest._handleSide = source.handleSide;
                dest.openingSymetry = source.openingSymetry;
                break;
            case SceneConstants.JoineryType.window:
                dest.openingMode = source.openingMode;
                dest.nbCasement = source.nbCasement;
                dest.slideDirection = source.slideDirection;
                dest._handleSide = source.handleSide;
                dest.openingSymetry = source.openingSymetry;
                break;
            case SceneConstants.JoineryType.frenchWindow:
                dest.nbDoors = source.nbDoors;

                dest._handleSide = source.handleSide;
                dest.openingSymetry = source.openingSymetry;
                break;
            case SceneConstants.JoineryType.pictureWindow:
                dest.nbDoors = source.nbDoors;
                dest.slideDirection = source.slideDirection;
                break;
            case SceneConstants.JoineryType.niche:
                dest.thickness = source.thickness;
                break;
            case SceneConstants.JoineryType.canopy:
                dest.nbCasement = source.nbCasement;
                break;
            case SceneConstants.JoineryType.cupboardDoor:
                dest.nbDoors = source.nbDoors;
                break;
            case SceneConstants.JoineryType.fixedWindow:
                break;
            case SceneConstants.JoineryType.velux:
                break;
            default:
                break;
        }

    }

    convertJoineryToDefaultProperties(joineryToConvert: Joinery) {
        var type = joineryToConvert.joineryType;
        joineryToConvert.length = this.joineriesDefaultProperties[type].length ?? joineryToConvert.length;
        joineryToConvert.height = this.joineriesDefaultProperties[type].height ?? joineryToConvert.height;
        joineryToConvert.floorHeight = this.joineriesDefaultProperties[type].floorHeight ?? joineryToConvert.floorHeight;
        var joinery: Door | Window | FrenchDoor | Niche | PictureWindow | CupboardDoor | Canopy
        switch (type) {
            case SceneConstants.JoineryType.door:
                joinery = joineryToConvert as Door;
                joinery.openingMode = this.joineriesDefaultProperties[type].openingMode ?? joinery.openingMode;
                joinery.nbDoors = this.joineriesDefaultProperties[type].nbDoors ?? joinery.nbDoors;
                joinery.slideDirection = this.joineriesDefaultProperties[type].slideDirection ?? joinery.slideDirection;
                joinery.handleSide = this.joineriesDefaultProperties[type].handleSide ?? joinery.handleSide;
                joinery.openingSymetry = this.joineriesDefaultProperties[type].openingSymetry ?? joinery.openingSymetry;
                break;
            case SceneConstants.JoineryType.window:
                joinery = joineryToConvert as Window;
                joinery.openingMode = this.joineriesDefaultProperties[type].openingMode ?? joinery.openingMode;
                joinery.nbCasement = this.joineriesDefaultProperties[type].nbCasement ?? joinery.nbCasement;
                joinery.slideDirection = this.joineriesDefaultProperties[type].slideDirection ?? joinery.slideDirection;
                joinery.handleSide = this.joineriesDefaultProperties[type].handleSide ?? joinery.handleSide;
                joinery.openingSymetry = this.joineriesDefaultProperties[type].openingSymetry ?? joinery.openingSymetry;
                break;
            case SceneConstants.JoineryType.frenchWindow:
                joinery = joineryToConvert as FrenchDoor
                joinery.nbDoors = this.joineriesDefaultProperties[type].nbDoors ?? joinery.nbDoors;

                joinery.handleSide = this.joineriesDefaultProperties[type].handleSide ?? joinery.handleSide;
                joinery.openingSymetry = this.joineriesDefaultProperties[type].openingSymetry ?? joinery.openingSymetry;
                break;
            case SceneConstants.JoineryType.pictureWindow:
                joinery = joineryToConvert as PictureWindow;
                joinery.nbDoors = this.joineriesDefaultProperties[type].nbDoors ?? joinery.nbDoors;
                joinery.slideDirection = this.joineriesDefaultProperties[type].slideDirection ?? joinery.slideDirection;
                break;
            case SceneConstants.JoineryType.niche:
                joinery = joineryToConvert as Niche;
                joinery.thickness = this.joineriesDefaultProperties[type].thickness ?? joinery.thickness;
                break;
            case SceneConstants.JoineryType.canopy:
                joinery = joineryToConvert as Canopy;
                joinery.nbCasement = this.joineriesDefaultProperties[type].nbCasement ?? joinery.nbCasement;

                // Lapeyre custom canopy size
                var component = joineryToConvert.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;

                if (component) {
                    if (component.joineryTypeId === "5fad1c4a8f1b8b7ad9c2ce98") {
                      joinery.computeLapeyreCanopyCasement();
                    }
                }
                break;
            case SceneConstants.JoineryType.cupboardDoor:
                joinery = joineryToConvert as CupboardDoor
                joinery.nbDoors = this.joineriesDefaultProperties[type].nbDoors ?? joinery.nbDoors;
                break;
            case SceneConstants.JoineryType.fixedWindow:
                break;
            case SceneConstants.JoineryType.velux:
                break;
            default:
                break;
        }

    }

    getWallDefaultHeight(): number {
        return (this.wallDefaultProperties.height);
    }

    setWallDefaultHeight(height: number) {
        this.wallDefaultProperties.height = height;
    }

    setWallDefaultProperties(wall: Wall) {
        this.wallDefaultProperties.height = wall.height;
        //this.wallDefaultProperties.thickness = wall.thickness;
    }

    convertWallToDefaultProperties(wallToConvert: Wall) {
        wallToConvert.height = this.wallDefaultProperties.height;
        //var item = angular.element($("#projectsTabcontainer")).scope().currentItem;
        // if(item === null) {
        wallToConvert.thickness = this.wallDefaultProperties.thickness;
        /* }else {
         wallToConvert.thickness = item.thickness*10;
         }*/
    }

    setCurrentToolParams(thickness: number) {
        this.wallDefaultProperties.thickness = thickness * 10;
    }

    /**
     * created worktop will have those component if not null
     * @param coatingAsset
     */
    setWorktopDefaultCoating(coatingAsset: any, index: string) {
        this.worktopDefaultProperties.coating = coatingAsset;
        this.worktopDefaultProperties.coatingIndex = index;
    }
    setWorktopDefaultCredence(coatingAsset: any, index: string) {
        this.worktopDefaultProperties.credence = coatingAsset;
        this.worktopDefaultProperties.credenceIndex = index;
    }

    get coating(): Coating | null {
        if (this.worktopDefaultProperties.coating !== null) {
            var coating;
            if ((this.worktopDefaultProperties.coating as any).colors !== undefined) {
                coating = new Coating((this.worktopDefaultProperties.coating as any)._id, (this.worktopDefaultProperties.coating as any).manufacturer, (this.worktopDefaultProperties.coating as any).retailer, 0, [(this.worktopDefaultProperties.coating as any).colors], (this.worktopDefaultProperties.coating as any).randomization, (this.worktopDefaultProperties.coating as any).floorGeneratorSettings, undefined);
            }
            else {
                coating = new Coating((this.worktopDefaultProperties.coating as any)._id, (this.worktopDefaultProperties.coating as any).manufacturer, (this.worktopDefaultProperties.coating as any).retailer, 0, (this.worktopDefaultProperties.coating as any).configs, (this.worktopDefaultProperties.coating as any).randomization, (this.worktopDefaultProperties.coating as any).floorGeneratorSettings, undefined);
            }
            coating.colorIndex = this.worktopDefaultProperties.coatingIndex;
            return coating;
        }
        return null;
    }
    get credence(): Credence | null {
        if (this.worktopDefaultProperties.credence !== null) {
            var credence;
            if ((this.worktopDefaultProperties.credence as any).colors !== undefined) {
                credence = new Credence((this.worktopDefaultProperties.credence as any)._id, (this.worktopDefaultProperties.credence as any).manufacturer, (this.worktopDefaultProperties.credence as any).retailer, 0, [(this.worktopDefaultProperties.credence as any).colors], (this.worktopDefaultProperties.credence as any).randomization, ComponentConstants.CredenceDefaultHeight, undefined);
            }
            else {
                credence = new Credence((this.worktopDefaultProperties.credence as any)._id, (this.worktopDefaultProperties.credence as any).manufacturer, (this.worktopDefaultProperties.credence as any).retailer, 0, (this.worktopDefaultProperties.credence as any).configs, (this.worktopDefaultProperties.credence as any).randomization, ComponentConstants.CredenceDefaultHeight, undefined);
            }
            credence.colorIndex = this.worktopDefaultProperties.credenceIndex;
            return credence;
        }
        return null;
    }

    setDefaultCoatingByHangtype(hangtype: number, coatingAsset: any, manufacturerName: string, objectType: string) {
        var str;
        switch(hangtype) {
            case Coating.HangType.door:
                str = 'Porte';
                break;

            case Coating.HangType.box:
                str = 'Caisson';
                break;

            case Coating.HangType.gutter:
                str = 'Gouttiere';
                break;

            case Coating.HangType.topBottom:
                str = 'HautBas';
                break;

            case Coating.HangType.sink:
                str = 'Evier';
                break;

            case Coating.HangType.mixer:
                str = 'Mitigeur';
                break;

            case Coating.HangType.front:
                str = 'Chant';
                break;

            default:
                return;
        }

        this.setDefaultCoating(str, coatingAsset, manufacturerName, objectType);
    }

    setDefaultCoating(key: string, coatingAsset: any, manufacturerName: string, objectType: string) {
        if (key.includes('Porte')) {
            if (manufacturerName === 'Lapeyre') {
                this.storageDefaultDoorCoating = coatingAsset
            }
            else {
                this.kitchenDefaultDoorCoating = coatingAsset;
            }
        }

        if (key.includes('Caisson')) {
            if (manufacturerName === 'Lapeyre') {
                if (SceneConstants.ArrangementType.bathroomCustomizableArrangements.indexOf(objectType) === -1) {
                    this.storageDefaultBoxCoating = coatingAsset;
                }
                else {
                    this.bathroomDefaultBoxCoating = coatingAsset;
                }
            }
            else {
                this.kitchenDefaultBoxCoating = coatingAsset;
            }
        }

        if (key.includes('Gouttiere')) {
            this.kitchenDefaultGutterCoating = coatingAsset;
        }

        if (key.includes('HautBas')) {
            this.kitchenDefaultTopBottomCoating = coatingAsset;
        }

        if (key.includes('Evier')) {
            this.kitchenDefaultSinkCoating = coatingAsset;
        }

        if (key.includes('Mitigeur')) {
            this.kitchenDefaultMixerCoating = coatingAsset;
        }

        if (key.includes('Panneau')) {
            this.kitchenDefaultPanelCoating = coatingAsset;
        }

        if (key.includes('Etagere')) {
            if (manufacturerName === 'Lapeyre') {
                this.storageDefaultShelfCoating = coatingAsset
            }
            else {
                this.kitchenDefaultShelfCoating = coatingAsset;
            }
        }

        if (key.includes('Fond')) {
            this.kitchenDefaultBackCoating = coatingAsset;
        }

        if (key.includes('Chant')) {
            this.bathroomDefaultMirrorBorderCoating = coatingAsset;
        }

        if (key.includes('Credence')) {
            this.kitchenDefaultCredenceCoating = coatingAsset;
        }

        if (key.includes('Plinthe')) {
            this.kitchenDefaultPlinthCoating = coatingAsset;
        }

        if (key.includes('Worktop')) {
            this.kitchenDefaultWorktopCoating = coatingAsset;
        }

        if (key.includes('Bouton')) {
            this.kitchenDefaultButtonCoating = coatingAsset;
        }

        if (key.includes('Plaque')) {
            this.kitchenDefaultFlatPieceCoating = coatingAsset;
        }
    }

    setDoorCustomizationGroups(customizationGroups: any) {
        this.doorCustomizationGroups = customizationGroups;
    }

    isCoatingCompatibleWithDoorCustomizationGroups(groups: any): boolean {
        if (!this.doorCustomizationGroups) {
            return(false);
        }
        for (var i = 0 ; i < (this.doorCustomizationGroups as any).length ; i++) {
            for (var j = 0 ; j < groups.length ; j++) {
                if ((this.doorCustomizationGroups as any)[i]._id === groups[j]._id) {
                    return(true);
                }
            }
        }

        return(false);
    }

    getDefaultCoating(key: string, manufacturerName: string, objectType: string): string {
        if (key.includes('Porte')) {
            if (manufacturerName === 'Lapeyre') {
                return (this.storageDefaultDoorCoating);
            }
            else {
                return (this.kitchenDefaultDoorCoating);
            }
        }

        if (key.includes('Caisson')) {
            if (manufacturerName === 'Lapeyre') {
                if (SceneConstants.ArrangementType.bathroomCustomizableArrangements.indexOf(objectType) === -1) {
                    return(this.storageDefaultBoxCoating);
                }
                else {
                    return(this.bathroomDefaultBoxCoating);
                }
            }
            else {
                return (this.kitchenDefaultBoxCoating);
            }
        }

        if (key.includes('Gouttiere')) {
            return (this.kitchenDefaultGutterCoating);
        }

        if (key.includes('HautBas')) {
            return (this.kitchenDefaultTopBottomCoating);
        }

        if (key.includes('Evier')) {
            return (this.kitchenDefaultSinkCoating);
        }

        if (key.includes('Mitigeur')) {
            return (this.kitchenDefaultMixerCoating);
        }

        if (key.includes('Panneau')) {
            return (this.kitchenDefaultPanelCoating);
        }

        if (key.includes('Etagere')) {
            if (manufacturerName === 'Lapeyre') {
                return (this.storageDefaultShelfCoating);
            }
            else {
                return (this.kitchenDefaultShelfCoating);
            }
        }

        if (key.includes('Fond')) {
            return (this.kitchenDefaultBackCoating);
        }

        if (key.includes('Chant')) {
            return (this.bathroomDefaultMirrorBorderCoating);
        }

        if (key.includes('Credence')) {
            return (this.kitchenDefaultCredenceCoating);
        }

        if (key.includes('Plinthe')) {
            return (this.kitchenDefaultPlinthCoating);
        }

        if (key.includes('Worktop')) {
            return (this.kitchenDefaultWorktopCoating);
        }

        if (key.includes('Bouton')) {
            return (this.kitchenDefaultButtonCoating);
        }

        if (key.includes('Plaque')) {
            return (this.kitchenDefaultFlatPieceCoating);
        }

        return ('');
    }

    getDefaultHandle(manufacturerName: string, objectType: string): string {
        if (manufacturerName === 'Lapeyre') {
            if (SceneConstants.ArrangementType.bathroomCustomizableArrangements.indexOf(objectType) === -1) {
                return(this.storageDefaultHandle);
            }
            else {
                return(this.bathroomDefaultHandle);
            }
        }
        else {
            return(this.kitchenDefaultHandle);
        }
    }

    setDefaultHandle(asset: any, manufacturerName: string, objectType: string) {
        if (manufacturerName === 'Lapeyre') {
            if (SceneConstants.ArrangementType.bathroomCustomizableArrangements.indexOf(objectType) === -1) {
                this.storageDefaultHandle  = asset;
            }
            else {
                this.bathroomDefaultHandle = asset;
            }
        }
        else {
            this.kitchenDefaultHandle = asset;
        }
    }

    setRoomCoatingClipboard(coating: Coating) {
        this.roomCoatingClipboard = coating.clone();
    }

    getRoomCoatingClipboard(): Coating | null {
        return(this.roomCoatingClipboard);
    }

    setDecoratedWallClipboard(wall: Wall) {
        this.decoratedWallClipboard = wall;
    }

    getDecoratedWallClipboard(): Wall | null {
        return this.decoratedWallClipboard;
    }

    setJoineryClipboard(joinery: Joinery) {
        this.joineryClipboard = joinery;
    }

    getJoineryClipboard(): Joinery | null {
        return this.joineryClipboard;
    }

}